import Projects from '@/resources/projects';

export default {
  fetchProjects({ commit }) {
    commit('startLoading');
    Projects.get().then(
      response => {
        commit('setProjects', response.data.data.projects);
        commit('stopLoading');
      },
      () => {
        commit('setError', 'something went wrong');
        commit('stopLoading');
      }
    );
  },
  toggleSidebar({ commit }) {
    commit('toggleSidebar');
  }
};
